import { IRequirement } from "../../../types/searchRequest";
import { ICollaborator } from "../../CredentialApp/types/credential";

import { FilterToggleState, FilterType } from "../../CredentialApp/types/assignment-filters";
import { RRAPitchbookCompany } from "./pitchbook";
import { VendorType } from "../common/constants";

export type CompanyListRef = string;
export interface ICompanyShortlist {
  company_id: string;
  meta_ref?: string; // added by BE after shortlist, FE is going to send only the company_id
};

export interface ICompanyList {
  _id: string;
  ref: string;
  // user input - do decode string on this
  // Ask BE to include these as empty arr by default
  name: string;
  requirements?: IRequirement[];
  shortlist?: ICompanyShortlist[];
  collaborators: ICollaborator[];
  active: number;
  vendor: VendorType;
  uid: string;
  updated_at: string;
  created_at: string;
  getro_list_id?: string;
};
export interface Company {
  id: string;
  metaRef?: string;
  companyName: string;
  lastFinancingDate?: string;
  lastFinancingSize?: string;
  lastFinancingDealType?: string;
  lastFinancingDealType2?: string;
  lastFinancingDealType3?: string;
  lastFinancingStatus?: string;
  activeInvestors?: string[];
  primaryIndustrySector?: string;
  primaryIndustryGroup?: string;
  verticals?: string;
  descriptions?: string;
  hqLocation?: string;
  revenue?: string;
  ebitda?: string;
  companyFinancingStatus?: string;
  ownershipStatus?: string;
  investors?: RRAPitchbookCompany['investors'];
  [key: string]: any;
}
export interface ICompanyColumn {
  id: string;
  header: string;
  accessorKey: string;
  defaultVisible: boolean;
  icon: string;
  dataType: string; // string, number, boolean, date, 'money'
}

export enum NumberUnitType {
  number = 'number',
  money = 'money',
  year = 'year',
}
export interface IRangeMeta {
  min_value: number;
  max_value: number;
  multiply_by: number;
  step: number;
  sub_label?: string;
  unit?: NumberUnitType;
  input_prefix?: string;
}

export interface SidebarFilter {
  id: string;
  toggle_state: FilterToggleState;
  title: string;
  section_id: string;
  enabled: boolean;
  icon?: string;
  filter_type: FilterType;
  kw_prefix?: string;
  search_field?: string;
  parent_id?: string;
  is_range?: boolean;
  range_meta?: IRangeMeta;
}

export interface SidebarFiltersType {
  [key: string]: SidebarFilter;
};

export interface CustomColumnDef {
  id?: string;
  accessorKey?: string;
  header?: string;
  size?: number;
  fixed?: "left" | "right";
  icon?: string;
};

export enum COMPANY_BUILDER_TAB_KEYS {
  'search' = 'search',
  'saved_companies' = 'saved-companies',
};

export const DEFAULT_TAB = COMPANY_BUILDER_TAB_KEYS.search;

export enum RecencyType {
  current = 'current',
  past = 'past',
  recent = 'recent',
  past_and_current = 'past_and_current'
};